module.exports = __webpack_public_path__ + "img/hoslogo9.5b0b1f4e.png";